"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FTruncateText = void 0;
const react_1 = __importDefault(require("react"));
const _helper_1 = require("../assets/js/_helper");
var FtruncateTextPlacementEnums;
(function (FtruncateTextPlacementEnums) {
    FtruncateTextPlacementEnums["bottom"] = "bottom";
    FtruncateTextPlacementEnums["bottomStart"] = "bottom-start";
    FtruncateTextPlacementEnums["bottomEnd"] = "bottom-end";
})(FtruncateTextPlacementEnums || (FtruncateTextPlacementEnums = {}));
const FTruncateText = ({ text, tooltip, style, width, length, className, placement = FtruncateTextPlacementEnums, children, }) => {
    return (react_1.default.createElement("div", { className: `f-truncate-text ${className} f-placement-${placement}`, title: `${text}`, style: Object.assign({}, style) },
        react_1.default.createElement("span", { style: { maxWidth: width, width: "100%" } }, (0, _helper_1.truncateMiddle)(text))));
};
exports.FTruncateText = FTruncateText;
//# sourceMappingURL=Ftruncate.js.map